import { exceptionStatusDefaultSelected } from '../DropDownOptions/logExceptionSearch';
import dayjs from 'dayjs';
export const logExceptionDefaultFormValues = {
  applicationName: [],
  exceptionStatus: exceptionStatusDefaultSelected,
  dateTime: [dayjs().subtract(4, 'hour').second(0), dayjs()],
  searchFieldValue: ''
};
